import { render, staticRenderFns } from "./CollectionPushContent.vue?vue&type=template&id=43e24cf2&scoped=true&"
import script from "./CollectionPushContent.vue?vue&type=script&lang=ts&"
export * from "./CollectionPushContent.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionPushContent.vue?vue&type=style&index=0&id=43e24cf2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e24cf2",
  null
  
)

export default component.exports